import axios from "axios"

const baseUrl = process.env.REACT_APP_API_BASE_URL;

export const searchAgentByNameOrEmailAPI = (payload) => axios
    .post(`https://api1.agentdesks.com/v1.0/agent/elastic/query`, payload)

export const fetchMetricsAPI = (filters, limit) => axios
    .get(`https://api1.agentdesks.com/v1.0/gabby/metrics?${filters ? filters : ""}offset=0&limit=${limit || 10}`)
